import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";
import { Observable, throwError, BehaviorSubject, of } from "rxjs";
import { catchError, filter, take, switchMap, tap } from "rxjs/operators";
import { SessionStore } from '../../../store/session.service';
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { Platform } from '@ionic/angular';
import { SessionExpiredModalService } from 'src/app/services/session-expired-modal.service';
import { UserLoginOutputResponse } from "../../../core/user/repository/user-remote-repository";
import { IRoomLocalRepository } from "src/app/core/chat/repository/room/room-local-repository";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  private excludedDomains = [ 'Login', 'http://localhost:8019']; // Add the domains you want to exclude

  constructor(
    private http: HttpClient,
    private router: Router,
    private sessionExpiredModal: SessionExpiredModalService,
    private platform: Platform,
    private roomLocalRepository: IRoomLocalRepository) { }


  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (this.shouldExcludeDomain(request)) {
      return next.handle(request);
    }

    if (SessionStore.user.Authorization) {
      request = this.addToken(request, SessionStore.user.Authorization);
    }

    return next.handle(request).pipe(

      catchError((error) => {
        if(error.url.includes('/Users/RefreshToken') && error.status === 401) {
          return throwError(error);
        }
        else if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(request, next);
        } else if (error.url.includes(`${environment.apiURLStage.slice(0, -1)}`) && error.status === 0) {
          return this.handle401Error(request, next);
        } else {
          return throwError(error);
        }
      })
    );
  }

  private shouldExcludeDomain(request: HttpRequest<any>): boolean {
    const url = request.url.toLowerCase();
    return this.excludedDomains.some((domain) => url.includes(domain.toLowerCase()));
  }

  private addToken(request: HttpRequest<any>, token: string) {

    return request.clone({
      setHeaders: {
        //'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${token}`,
      },
    });

  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    // if not getting the new token yet
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.refreshToken().pipe(
        switchMap((data: UserLoginOutputResponse) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(data?.data?.authorization);
          return next.handle(this.addToken(request, data?.data?.authorization));
        })
      );
    } else {
      // get new token
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addToken(request, jwt));
        })
      );
    }
  }


  //this method refresh token is declared here temporary beacouse a circular error
  refreshToken() {
    let channelId;
    if ( this.platform.is('desktop') || this.platform.is("mobileweb")){
      channelId = 2
    } else {
      channelId = 1
    }

    return this.http
      .post<UserLoginOutputResponse>(`${environment.apiURLStage}Users/RefreshToken`, {
        authorization: SessionStore.user.Authorization,
        refreshToken: SessionStore.user.RefreshToken,
        channelId
      },)
      .pipe(
        tap((data) => {

          SessionStore.user.Authorization = data.data.authorization;
          SessionStore.user.RefreshToken = data.data.refreshToken;
          //const userData = UserLoginMapper.toDomainData(data)
          //const session: UserSession = Object.assign(SessionStore.user, userData)
          //SessionStore.reset(session)ta

        }),
        catchError((error) => {
          console.log("refresh token error",error)
          SessionStore.setInativity(false)

          if(window.location.pathname.includes('/home/')) {
          
            const sessionExpiredMessage =
              'A sua sessão expirou. Por favor, faça login novamente para continuar.';
            const goToAuth = () => {
              if (environment.production) {
                window.location.pathname = '/auth';
              } else if (!this.router.url.startsWith('/auth')) {
                this.router.navigateByUrl('/auth', { replaceUrl: true });
              }
            };
            console.log('sessionExpiredModal', this.sessionExpiredModal)
            this.roomLocalRepository.clear();
            void this.sessionExpiredModal.present(sessionExpiredMessage, goToAuth);
          }
          return of(false);
        })
      );
  }

}

export const tokenInterceptor = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptor,
  multi: true
};
